import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"
import moment from 'moment';
import VueI18n from "vue-i18n";
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || "zh",
  messages: {
    "en": require("../../../../../lang/en"),
    "zh": require("../../../../../lang/zh"),
  },
});

export default {
    props: ["bindCar"],
    data() {
        return {
            activeName: 'first',
            activeSelect: 'first',
            dayLoading: false,
            dayOption: {},
            hourLoading: false,
            hourOption: {},
            orgId: '',
            carId: '',
            changeValue: [],
            height: '500',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columnsAll: [
                {
                    prop: "carId",
                    label: this.$t('VehicleAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('VehicleAnalysis.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('VehicleAnalysis.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('VehicleAnalysis.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "orgName",
                    label: this.$t('VehicleAnalysis.orgName'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('VehicleAnalysis.workHour'),
                    align: "center",
                },
                {
                    prop: "useTimeRate",
                    label: this.$t('VehicleAnalysis.useTimeRate'),
                    align: "center",
                }
            ],
            columnsOne: [
                {
                    prop: "carId",
                    label: this.$t('VehicleAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('VehicleAnalysis.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('VehicleAnalysis.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('VehicleAnalysis.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('VehicleAnalysis.terminalId'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('VehicleAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "driverName",
                    label: this.$t('VehicleAnalysis.driverNum'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('VehicleAnalysis.orgName'),
                    align: "center",
                },
                {
                    prop: "startTime",
                    label: this.$t('VehicleAnalysis.startTime'),
                    align: "center",
                },
                {
                    prop: "endTime",
                    label: this.$t('VehicleAnalysis.endTime'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('VehicleAnalysis.workHour'),
                    align: "center",
                },
               
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        handleClick(event) {
            this.activeSelect = event.name
            if (this.activeSelect == 'first') {
                this.$nextTick(() => {
                    this.getDayUseRate()
                })
            } else {
                this.$nextTick(() => {
                    this.getDayUseRate()
                })

            }
        },
        handleChange(val) {
            this.activeName = val.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.initQuery('all')
                })
            } else {
                this.$nextTick(() => {
                    this.getHourUseRate()
                })

            }
        },
        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },
        changeTime() {
            this.getDayUseRate()
            this.getMonthOrderList('all')
            this.getHourUseRate()
        },
        getDayUseRate() {
            this.dayLoading = true
            let Data = []
            let dayUse = []
            let dataShadow = []
            let workTime = []
            let timeType = ''
            if (this.activeSelect == 'first') {
                timeType = '24'
            } else {
                timeType = '8'
            }
            let param = {
                orgId: Number(this.orgId),
                carId: this.carId,
                timeType: timeType,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("VehicleAnalysis/GET_DAILYUSERATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            Data.push(item.date)
                            workTime.push({ time: item.workTime, date: item.date })
                            dataShadow.push(300)
                            if (item.dayUseRate == null) {
                                dayUse.push(0)
                            } else {
                                if (item.dayUseRate.indexOf('%') > -1) {
                                    let num = item.dayUseRate.split('%')[0]
                                    if (num > 300) {
                                        dayUse.push(300)
                                    } else {
                                        dayUse.push(Number(num))
                                    }
                                }
                            }
                        })
                        let maxNumber = Math.ceil(Math.max(...dayUse))
                        dataShadow.map((t, k) => {
                            dataShadow[k] = maxNumber
                        })
                        this.DayUseRate(Data, dayUse, workTime)
                    }
                }
                this.dayLoading = false
            }).catch(err => {
                this.dayLoading = false
            })
        },
        DayUseRate(Data, dayUse, workTime) {
            let option = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: function (item) {
                        let workHour = ''
                        workTime.map((t, k) => {
                            if (item[0].name == t.date) {
                                workHour = t.time
                            }
                        })
                        return i18n.t('common.date')+':'+ item[0].name + '<br/>' + i18n.t('VehicleAnalysis.workHour')+':' + workHour + 'h' + '<br/>' + i18n.t('VehicleAnalysis.useRate')+':' + item[0].value + '%'
                    },
                },
                legend: {
                    left: '10',
                    data: [this.$t('VehicleAnalysis.useRate')],
                    itemWidth: 12, 
                    itemHeight: 12, 
                    textStyle: {
                        color: '#fff'
                    }
                },
                toolbox: {
                    right: '10',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false, backgroundColor: '#081831', textareaColor: '#081831', textColor: '#fff' },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                        restore: { show: true },
                        saveAsImage: { name: this.$t('VehicleAnalysis.carDayEfficiency'), show: true, backgroundColor: '#081831' }
                    },
                    iconStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    splitLine: { show: false },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    data: Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '2%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: '#fff'
                    },
                    splitLine: {
                        show: true, lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    min: 0,
                }],
                series: [
                    {
                        name: this.$t('VehicleAnalysis.useRate'),
                        data: dayUse,
                        type: 'bar',
                        barCategoryGap: '40%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                          },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#1e89f8' },                  
                                        { offset: 1, color: '#4fa3fb' },                   
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.dayOption = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('VehicleAnalysis/GET_USERATEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                carId: this.carId,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('VehicleAnalysis/GET_USERATEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getHourUseRate() {
            this.hourLoading = true
            let Data = []
            let dayUse = []
            let dataShadow = []
            let workTime = []
            let timeType = ''
            if (this.activeSelect == 'first') {
                timeType = '24'
            } else {
                timeType = '8'
            }
            let param = {
                orgId: Number(this.orgId),
                carId: this.carId,
                timeType: timeType,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("VehicleAnalysis/GET_SELECTALLCARANDWORKTIME", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            Data.push(item.carId)
                            workTime.push(item.workTime)
                            dataShadow.push(300)
                        })
                        this.HourUseRate(Data, workTime)
                    }
                }
                this.hourLoading = false
            }).catch(err => {
                this.hourLoading = false
            })
        },
        HourUseRate(Data, workTime) {
            let option = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: function (item) {
                        return this.$t('VehicleAnalysis.carId')+':' + item[0].name + '<br/>' + this.$t('VehicleAnalysis.workHour')+':' + item[0].value + 'h'
                    },
                },
                legend: {
                    left: '10',
                    data: [this.$t('VehicleAnalysis.useRate')],
                    itemWidth: 12, 
                    itemHeight: 12, 
                    textStyle: {
                        color: '#fff'
                    }
                },
                toolbox: {
                    right: '10',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false, backgroundColor: '#081831', textareaColor: '#081831', textColor: '#fff' },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                        restore: { show: true },
                        saveAsImage: { name: this.$t('VehicleAnalysis.carDayEfficiency'), show: true, backgroundColor: '#081831' }
                    },
                    iconStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    splitLine: { show: false },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    data: Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '2%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: '#fff'
                    },
                    splitLine: {
                        show: true, lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    min: 0,
                }],
                series: [
                    {
                        name: this.$t('VehicleAnalysis.hour'),
                        data: workTime,
                        type: 'bar',
                        barCategoryGap: '40%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                          },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#1e89f8' },                   
                                        { offset: 1, color: '#4fa3fb' },                   
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.hourOption = option
        },
        downCar() {
            if (this.type == 'one') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/useDate/uploadCarTimePage?orgId=${this.orgId}&selectType=${1}&carId=${this.bindCar}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/useDate/uploadCarTimePage?orgId=${this.orgId}&selectType=${1}&carId=${this.bindCar}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    }
                }
            } else {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/useDate/uploadCarTimePage?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/useDate/uploadCarTimePage?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                        location.href = url
                    }
                }
            }
           
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
    }
}
